var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("概要")]),_c('p',[_vm._v("工事中")])])
}]

export { render, staticRenderFns }